import React, { useState, useContext } from "react";
import { Box, TextField, IconButton, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { HourlyDataContext } from "../../Contexts/HourlyDataContext";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "4fr 4fr 1fr",
    gridGap: theme.spacing(1),
  },
  flexColContainer: {
    display: "flex",
    flexDirection: "column",
  },
  flexColItem: {
    marginBottom: theme.spacing(1),
  },
  flexRowContainer: {
    display: "flex",
  },
  flexRowItem: {
    flexGrow: 1,
    width: "100%",
    // whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));

const BranchItem = ({
  branchObj,
  className,
  deleteItem,
  branchModel,
  ...otherProps
}) => {
  const { assignedBranchId, assignedAmount } = branchObj;
  const classes = useStyles();

  return (
    <Box className={clsx(classes.gridContainer, className)} {...otherProps}>
      <TextField
        disabled
        fullWidth
        label={branchModel.assignedBranchId.displayName}
        // value={branchModel.assignedBranchId.displayValue(assignedBranchId)}
        value={assignedBranchId}
        {...branchModel.assignedBranchId.textFieldProps}
      />
      <TextField
        disabled
        fullWidth
        label={branchModel.assignedAmount.displayName}
        value={branchModel.assignedAmount.displayValue(assignedAmount)}
        {...branchModel.assignedAmount.textFieldProps}
      />
      <Tooltip title="Remove branch">
        <IconButton onClick={() => deleteItem(branchObj)}>
          <DeleteForeverIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default BranchItem;
